import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.css']
})
export class SubMenuComponent implements OnInit {

  @Input() list: any;

  data: any = []

  toggleFolder() {
    this.list.isOpen = !this.list.isOpen;
  }
  constructor() { }

  ngOnInit(): void {
    this.data = this.list
    console.log(this.data)
  }

  openFolder(list: any){
    console.log(list)
    if(list.children != null && list.children != undefined && list.children.length != 0){
      list.isOpen = !list.isOpen
    }
  }

}
